module.exports = "/assets/with-account-active@2x.png?b3Db/vM";